<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h10"><span class="th10">Dedication</span></h1>
<p class="p1">To T.J. Masters. You have a big heart, my friend. Much love, Sue xx</p>
<p class="p2"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?97ed91b0